$(function () {

   $(document).on("keyup", "#txtTripSearch", function (e) {
        //doTripFind();
        refrehTripList(false);
    })

    //trip list paging (load more)
    $(document).on("click", ".triplist_loadmore", function (e) {
        e.preventDefault();       
        refrehTripList(true);
    })

    //trip list sorting
    $(document).on("click", ".trip-plan-table th", function (e) {
        e.preventDefault(); 

        var current=triplist_current_sort();
       
        var sNewSort=$(this).data("sort");
        var sNewOrder="D";
        if (sNewSort == current.data("sort")) {
            //toggle
            sNewOrder = (current.hasClass("sorting_desc") ? "sorting_asc" : "sorting_desc")
        }
        else {
            sNewOrder = (sNewSort == "NAME" || sNewSort == "CLIENT" ? "sorting_asc" : "sorting_desc") 
        }
      
        //remove all old ones
        $(".trip-plan-table th").removeClass("sorting_asc").removeClass("sorting_desc");

        $(this).addClass(sNewOrder);
       
        refrehTripList(false);
    })

}) 

function triplist_current_sort() {
    var e= $(".trip-plan-table th.sorting_asc");
    if (e.length==0){e= $(".trip-plan-table th.sorting_desc")  }
    return e;                                                   
}

function refrehTripList(loadmore) {

    if ($("#triplist").length==0){return;}
    element_Blur("#triplist",true)

    var val=$("#txtTripSearch").val()
    //ignore value search when less then 3 chars
    if (val.length < 3) {val= ""; }  

    var current=triplist_current_sort();
    var clientid=$(".trip-plan-table").data("client-id");
    var pg=1;
    if (loadmore) { pg = $(".triplist_loadmore").data("page"); }
   
    var req = {
        Value: val,
        Sort: current.data("sort"),
        SortOrder: (current.hasClass("sorting_asc")?"A":"D"),
        Page: pg,
        ClientID: clientid
    };

    
    var DTO = { 'Req': req };
    DynaProxy.invoke("GetReports", DTO, function (data) {
        $("#triplist").find("tr.load-more").remove();                
        if (loadmore) { $("#triplist").find("tbody").append(data);}
        else { $("#triplist").find("tbody").html(data); }
        element_Blur("#triplist",false)
        init_trip_trav_cards();

    }, function (data) {
        showSupportNotification('Unable to get Trip Plan.');
        element_Blur("#triplist",false)
    });
    return false;
}
